import { theme } from 'antd';

const ChatPageStyles = () => {
    const { token } = theme.useToken();

    return {
        layout: {
            height: '100vh',
            backgroundColor: token.colorBgBase,
        },
    };
};

export default ChatPageStyles;
